/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { ReactNode, useEffect } from "react";
import PropTypes from "prop-types";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import "typeface-noto-sans";

import Header from "./header";
import Footer from "./footer";
import "./layout.css";

const theme = createMuiTheme({
  typography: {
    fontFamily: [
      "noto-sans",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
});

interface LayoutProps {
  language: string;
  children: React.ReactNode;
}

function Layout (props: LayoutProps) {
  useEffect(()=> {
    import('scrollreveal').then(({ default: ScrollReveal }) => {
      const sr = ScrollReveal()
      sr.reveal('.reveal', {
        delay: 500,
        distance: '150%',
        origin: 'bottom',
      });
    });
  }, [])
 
  return (
    <ThemeProvider theme={theme}>
      <Header language={props.language} />
      <div>{props.children}</div>
      <Footer language={props.language} />
    </ThemeProvider>
  );
}

export default Layout;
